import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import {Logout as LogoutIcon} from "@mui/icons-material";
import { Box } from "@mui/material";
import {userIsNotLoggedIn} from "../../utils.js";
import Login from "../forms/Login.js";
import Button from "@mui/material/Button/Button.js";
import CreateNewOrganization from "../forms/CreateNewOrganization.js";
import {ROUTES_MY_ACCOUNT,} from "../../utils/Constants.js";
import {logout, userLoggedIn} from "../../redux/user/Action.js";

import {isEmpty} from "weed-js";

export const AccountStatus = ({
    loggedInUser,
    userProfile,
    setHideCreatePaidAccount,
    setLoggedInUser,
    setUserProfile,
    setMainMenuAccordionExpanded
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const setOrganizations = (orgs) => userLoggedIn({organizations: orgs});

    const organizations = useSelector(state => state.userReducer.loggedInUser.organizations || []);
    const firstName = loggedInUser?.first_name ?? "";

    const createAccount = () => {
        if (isEmpty(loggedInUser) || isEmpty(userProfile)) {
            return <>
                <p className={"promo-container"}>The first month is <span className={"promo"}>FREE</span> when you enter promo code <span className={"promo"}>CANOLD1025</span> at checkout &rarr; </p>
                <Button
                    variant={"outlined"}
                    className="secondary"
                    id={"create-account-menu-button"}
                    onClick={() => {
                        setMainMenuAccordionExpanded(false);
                        setHideCreatePaidAccount(false);
                    }
                    }>
                Create Account
                </Button>
                &nbsp;&nbsp;
            </>
        }
        return null;
    }

    const whenLoggedIn = <>
        <Link
            id="welcome-user"
            onClick={() =>
                setMainMenuAccordionExpanded(false)}
            className="menubar menu-item"
            to={ROUTES_MY_ACCOUNT}
        >
            Welcome, {firstName}
        </Link>
        <Box className="menu-item">
            <Button id="logout" variant="outlined" className="secondary" onClick={() => {
                setMainMenuAccordionExpanded(false);
                dispatch(logout()).then(() => {
                    dispatch(userLoggedIn({user: null, organizationUsers: [], organizations: []}));
                    navigate("/");
                });
            }}>
                <LogoutIcon className="logout-icon"/>&nbsp; Logout
            </Button>
        </Box>
    </>;

    console.warn("Reminder: implement setMainMenuAccordionExpanded in CreatePaidAccount");

    const whenLoggedOut = (
        <>
            {createAccount()}
            <Login
                loggedInUser={loggedInUser}
                userProfile={userProfile}
                setLoggedInUser={setLoggedInUser}
                setUserProfile={setUserProfile}
                organizations={organizations}
                setOrganizations={setOrganizations}
                setMainMenuAccordionExpanded={setMainMenuAccordionExpanded}
            />
        </>
    );

    return userIsNotLoggedIn(loggedInUser) ? whenLoggedOut : whenLoggedIn;
};
